enum PinataTableTrackerResult {
  Success = 'success',
  Failure = 'failure',
}

export { PinataTableTrackerResult };
